// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tV7UXrBSZENhazBvKxDs{flex-grow:1;justify-content:flex-end;display:flex}.WG6zKBDrmLc0KzvMkDxh{background:var(--background-primary-inverted-primary);box-shadow:var(--shadow-dropdown2);flex-direction:column;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `tV7UXrBSZENhazBvKxDs`,
	"content": `WG6zKBDrmLc0KzvMkDxh`
};
export default ___CSS_LOADER_EXPORT___;
